var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"ol-loading"}},[(_vm.value)?_c('div',[_c('div',{staticClass:"ol-loading"},[_c('img',{staticClass:"ol-loading__image",attrs:{"src":"https://img.kandagar.com/images/1/wheel-forever.gif","alt":""}}),_vm._v(" "),_c('div',{staticClass:"ol-loading__text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad418f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/Loading.vue
// module id = 60
// module chunks = 0